<template>
  <v-chip class="ma-2 pa-4" color="blue lighten-4" text-color="primary" style="font-size: 16px;">
    <v-icon left color="primary">mdi-upload</v-icon>
    Uploading... {{ Math.ceil(progress) }}%
    <v-progress-circular
      :size="24"
      :width="3"
      :value="progress"
      color="primary"
      class="ml-2"
    />
  </v-chip>
</template>




<script setup>
defineProps({
    progress: {
        type: Number,
        required: true,
        default: 0
    },
    uploadedCount: {
        type: Number,
        required: true,
        default: 0
    },
    totalCount: {
        type: Number,
        required: true,
        default: 0
    }
})
</script>

<style scoped>
.progress-bar-container {
  width: 100%;
}

.progress-bar-track {
  background-color: #dbeafe; /* light blue */
  border-radius: 10px;
  height: 12px;
  overflow: hidden;
}

.progress-bar-fill {
  background: linear-gradient(90deg, #2196f3, #64b5f6);
  height: 100%;
  transition: width 0.4s ease-in-out;
  border-radius: 10px 0 0 10px;
}
</style>
